import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

const InputHint = (props) => {
  const {
    value, minLength, maxLength, isBlock,
  } = props;

  const items = [];
  if (props.hasNumbers) {
    items.push({ id: 'password_tip.numbers', expression: /\d/ });
  }
  if (props.hasLetters) {
    items.push({ id: 'password_tip.letters', expression: /[a-z]+/g });
  }
  if (props.hasCapitalLetters) {
    items.push({ id: 'password_tip.letters_capital', expression: /[A-Z]+/g });
  }
  if (minLength && maxLength && maxLength > minLength) {
    items.push({
      id: `password_tip.length.${minLength}.to.${maxLength}`,
      expression: new RegExp(`^[a-zA-Z0-9]{${minLength},${maxLength}}$`, 'g'),
    });
  } else if (minLength) {
    items.push({
      id: `password_tip.length.min.${minLength}`,
      expression: new RegExp(`[a-zA-Z0-9]{${minLength},}`),
    });
  } else if (maxLength) {
    items.push({
      id: `password_tip.length.max.${maxLength}`,
      expression: new RegExp(`^[a-zA-Z0-9]{1,${maxLength}}$`),
    });
  }

  const baseClassName = isBlock ? 'input-message' : 'input-txt';
  const className = isBlock ? 'input-message' : 'input-txt__hint';
  const titleClassName = cx({
    [`${baseClassName}__hint-title`]: items.length > 0,
    [`${baseClassName}__hint-item`]: !items.length,
  });
  const listClassName = isBlock ? 'input-message__hint-list' : 'input-txt__hint-list';

  return (
    <span className={className}>
      <span className={titleClassName}>
        <FormattedMessage id={props.titleKey} />
      </span>
      {items.length > 0
        && (
        <ul className={listClassName}>
          {items.map((item) => {
            const classname = cx({
              [`${baseClassName}__hint-item`]: true,
              [`${baseClassName}__hint-item--active`]: value && value.match(item.expression),
            });
            return (
              <li className={classname} key={item.id}>
                <FormattedMessage id={item.id} />
              </li>
            );
          })}
        </ul>
        )}
    </span>
  );
};

InputHint.propTypes = {
  value: PropTypes.string,
  hasNumbers: PropTypes.bool,
  hasLetters: PropTypes.bool,
  hasCapitalLetters: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  titleKey: PropTypes.string,
  isBlock: PropTypes.bool,
};

export default InputHint;
